import React, { useEffect, useState } from 'react';

const AboutSection = () => {
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    const timestamp = new Date().getTime();
    setImageUrl(`img/about/nitin-gadkari.jpg?t=${timestamp}`);
  }, []);

  return (
    <div className="about_section">
      <style>{`
        .about_section .a_inner {
          display: flex;
          flex-direction: row;
          height: 100%;
          background-color: #fff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
        }
        .about_section .a_inner .leftpart {
          padding: 30px;
          flex: 1 1 60%;
          min-width: 0;
        }
        .about_section .a_inner .leftpart .title {
          font-size: 24px;
        }
        .about_section .a_inner .leftpart .text-wrap {
          padding-right: 10px;
        }
        .about_section .a_inner .leftpart p {
          font-size: 16px;
        }
        .about_section .a_inner .leftpart .name {
          font-size: 18px;
        }
        .about_section .a_inner .leftpart .occ {
          font-size: 16px;
        }
        .about_section .a_inner .image-holder {
          flex: 1 1 40%;
          position: relative;
          background-color: #e0e0e0;
          display: block;
          min-height: auto;
        }
        .about_section .heading-title {
          font-size: 40px;
        }

        @media (max-width: 1200px) {
          .about_section .a_inner .leftpart {
            padding: 20px;
          }
          .about_section .a_inner .leftpart .title {
            font-size: 20px;
          }
          .about_section .a_inner .leftpart .text-wrap {
            padding-right: 0;
          }
          .about_section .a_inner .leftpart p {
            font-size: 14px;
          }
          .about_section .a_inner .leftpart .name {
            font-size: 16px;
          }
          .about_section .a_inner .leftpart .occ {
            font-size: 14px;
          }
        }

        @media (max-width: 768px) {
          .about_section .a_inner {
            flex-direction: column;
            height: auto;
          }
          /* In row layout, 60%/40% controls width; once stacked into a
             column, that same basis controls height instead, stretching
             .leftpart far past its content and leaving a blank gap
             before the image. Reset both to their natural content size. */
          .about_section .a_inner .leftpart,
          .about_section .a_inner .image-holder {
            flex: none;
          }
          /* Show the image first, then the text content below it. */
          .about_section .a_inner .image-holder {
            order: 1;
            height: 200px;
            min-height: 200px;
          }
          .about_section .a_inner .leftpart {
            order: 2;
          }
          .about_section .heading-title {
            font-size: 28px;
          }
        }

        @media (max-width: 480px) {
          .about_section .heading-title {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="fn_cs_about">
        <div className="container">
          {/* Heading and Subheading */}
          <div style={{
            textAlign: 'center',
            marginBottom: '60px'
          }}>
            <h2 className="heading-title" style={{
              fontWeight: '400',
              color: '#333',
              marginBottom: '15px',
              lineHeight: '1.2'
            }}>
              Vidarbha: The Next Growth Region
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#666',
              maxWidth: '800px',
              margin: '0 auto',
              lineHeight: '1.6'
            }}>
              Leadership messages outlining a roadmap of development, innovation, and opportunity.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(600px, 100%), 1fr))',
            gap: '40px',
            alignItems: 'stretch'
          }}>
            {/* First Column */}
            <div className="a_inner">
              <div className="leftpart">
                <div className="title_holder">
                  <h3 className="title" style={{
                    marginBottom: '20px',
                    color: '#333',
                    fontWeight: '400'
                  }}>Vidarbha Envisioned</h3>
                  <div className="text-wrap">
                    <p style={{
                      marginBottom: '15px',
                      lineHeight: '1.6',
                      color: '#555'
                    }}>
                      Vidarbha holds the potential to become one of India's most dynamic engines of industrial growth, driven by fresh investments, emerging enterprises, and a rapidly evolving innovation ecosystem. With strategic infrastructure, skilled talent, and policy support, the region is poised to attract global partnerships and sustainable development.                    </p>
                  </div>
                </div>
                <div className="sign_holder" style={{ marginTop: '20px' }}>
                  <h3 className="name" style={{
                    fontWeight: '600',
                    color: '#333',
                    marginBottom: '5px'
                  }}>Hon'ble Shri Nitin Ji Gadkari</h3>
                  <p className="occ" style={{
                    color: '#666'
                  }}>Union Minister, MoRTH, GOI</p>
                </div>
              </div>

              {/* Image on the right side */}
              <div className="image-holder">
                <img
                  src={process.env.PUBLIC_URL + "/img/about/nitin-gadkari.svg"}
                  alt="Hon'ble Shri Nitin Ji Gadkari"
                  onError={(e) => {
                    console.error('Image failed to load:', e.target.src);
                    e.target.style.backgroundColor = '#ffebee';
                    e.target.alt = 'Image not found';
                  }}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center 10%',
                    display: 'block'
                  }}
                />
              </div>
            </div>

            {/* Second Column */}
            <div className="a_inner">
              <div className="leftpart">
                <div className="title_holder">
                  <h3 className="title" style={{
                    marginBottom: '20px',
                    color: '#333',
                    fontWeight: '400'
                  }}>Empowering Vidarbha</h3>
                  <div className="text-wrap">
                    <p style={{
                      marginBottom: '15px',
                      lineHeight: '1.6',
                      color: '#555'
                    }}>
                      Vidarbha’s strategic location and rich natural resources make it a strong driver of India’s economic growth, offering vast opportunities in agriculture, manufacturing, and technology. Through infrastructure development and investor-friendly policies, we are building a sustainable and balanced industrial ecosystem.                    </p>
                  </div>
                </div>
                <div className="sign_holder" style={{ marginTop: '20px' }}>
                  <h3 className="name" style={{
                    fontWeight: '600',
                    color: '#333',
                    marginBottom: '5px'
                  }}>Hon'ble Shri Devendra Ji Fadnavis</h3>
                  <p className="occ" style={{
                    color: '#666'
                  }}>Chief Minister, Maharashtra</p>
                </div>
              </div>

              {/* Image on the right side */}
              <div className="image-holder">
                <img
                  src={process.env.PUBLIC_URL + "/img/about/devendra.svg"}
                  alt="Vidarbha Development"
                  onError={(e) => {
                    console.error('Image failed to load:', e.target.src);
                    e.target.style.backgroundColor = '#ffebee';
                    e.target.alt = 'Image not found';
                  }}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center 10%',
                    display: 'block'
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
